import React, {useEffect, useState} from 'react';
import {OcrResultEditorWrapper, StyledTextarea} from "./OcrResultEditor.styled";
import {useTranslation} from "react-i18next";
import {ResultText} from "../../../../ocr-batch/components/ResultPanel/ResultPanel.styled";
import PageNavigation from "../../../../../components/ocr-batch/PageNavigation";
import {Stack, Typography} from "@mui/material";

interface OcrResultEditorProps {
    pages: {pageNumber: number; text: string, confidencePercent: number}[];
    editedPages: { pageNumber: number; text: string; confidencePercent: number}[];
    onChange: (page: number, value: string) => void;
}

const OcrResultEditor = ({pages, editedPages, onChange}: OcrResultEditorProps) => {
    const {t} = useTranslation();

    const [currentPage, setCurrentPage] = useState(1);
    const [isDirty, setIsDirty] = useState(false);
    const [value, setValue] = useState(
        editedPages.find(p => p.pageNumber === 1)?.text ?? ''
    );

    useEffect(() => {
        setCurrentPage(1);
    }, [pages]);

    useEffect(() => {
        const edited = editedPages.find(p => p.pageNumber === currentPage)?.text ?? '';
        const original = pages.find(p => p.pageNumber === currentPage)?.text ?? '';

        setValue(edited);
        setIsDirty(edited !== original);
    }, [currentPage, pages, editedPages]);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = e.target.value;
        const original = pages.find(p => p.pageNumber === currentPage)?.text;

        setValue(newValue);
        setIsDirty(newValue !== original);

        onChange(currentPage, newValue);
    };

    return (
        <OcrResultEditorWrapper>
            {editedPages.length === 0 ? (
                <ResultText aria-live="polite" aria-label={t('digitizationEdition.messages.noResultDataFoundError')}>
                    {t('digitizationEdition.messages.noResultDataFoundError')}
                </ResultText>
            )
            : (
                <Stack direction="column" sx={{width: '100%', height: '100%'}}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{borderBottom: 'solid 0.8px #E2E8F0'}}>
                        <Typography variant="body2" color="text.secondary" fontWeight={500} sx={{ml: '16px'}}>
                            {t('digitizationDetails.filePreview.confidencePercentage', {percentage: pages[currentPage - 1].confidencePercent})}
                        </Typography>

                        <PageNavigation
                            currentPage={currentPage}
                            totalPages={editedPages.length}
                            setCurrentPage={setCurrentPage}
                        />
                    </Stack>


                    <StyledTextarea
                        value={value}
                        onChange={handleChange}
                        spellCheck={false}
                        $isDirty={isDirty}
                    />
                </Stack>
            )}
        </OcrResultEditorWrapper>
    );
};

export default OcrResultEditor;